@import "~@uipath/apollo-core/src/scss/base-host.scss";

:host {
  display: flex;
  font-family: $font-normal;

  .menu-container {
    display: inline-block;
    width: auto;
    height: auto;
    cursor: pointer;
    position: relative;
  }

  .menu-item-header {
    color: var(--color-foreground);
    font-family: $font-normal;
    font-weight: $font-weight-semibold;
    font-size: $font-m-size;
    line-height: $font-m-line-height;
    padding: $pad-m $pad-xxxl;
    text-align: left;
  }

  .menu-item-content {
    line-height: $font-m-line-height;
    padding-left: $pad-xxxl;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: $font-normal;
    font-style: normal;
    font-weight: normal;
    font-size: $font-m-size;
    color: var(--color-foreground-de-emp);
  }

  .menu-divider {
    margin: $pad-s 0px;
    border-bottom: $stroke-s solid var(--color-border-de-emp);
  }

  .copy-icon {
    margin: 0 $pad-l;
  }

  .portal-badge {
    right: -6px;
    top: -8px;
    width: 20px;
    height: 20px;
    line-height: $font-link-line-height;
    position: absolute;
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    pointer-events: none;
    border: solid $stroke-m var(--color-foreground-inverse);
    background-color: var(--color-background-inverse);
    font-size: $font-m-size;
    color: var(--color-foreground-inverse);
    font-weight: bold;

    &.show {
      visibility: visible;
    }

    &.hide {
      visibility: hidden;
    }
  }
}
